<template>
<div class="page-container">
	<div class="bind_logo">
	  <img class="logo-img" src="../assets/imgs/yixi-logo.jpg" alt="YIXI LOGO" srcset="" />
	</div>
	<div class="bind_mobile">
		<div class="bind-dialog">
			<div class="bind-title">绑定你的手机号</div>
			<div class="inputs-bl">
				<div class="input-wrap">
				  <input type="text" 
				  placeholder="请输入手机号码" 
				  @keyup="onInput($event, 'phone')"
				  @afterpaste="onInput($event, 'phone')"
				  maxlength="11"
				  v-model="form.phone"/>
				</div>
				<div class="input-code">
					<div class="input-wrap">
					  <input type="password" 
					  placeholder="请输入验证码" 
					  @input="onInput($event, 'captcha')"
					  v-model="form.captcha"/>
					</div>
					<span class="captcha_btn" :class="{ disabled: disabledBtn }" @click="sendCaptcha">
					  {{ captchaSeconds > 0 ? `${captchaSeconds}秒` : '获取验证码' }}
					</span>
				</div>
				
			</div>
			<div class="bind-login" :class="{ disabledcode: disabledcodeBtn }" @click="bindMobile()">确认登录</div>
		</div>
	</div>
	
</div>
</template>

<script>
import requestApi from '@/service';
import configFields from '@/utils/configFields';
const { DEFAULT_NATION_CODE } = configFields;
export default {
	data() {
		return {
			form: {
			  phone: '',
			  captcha: '',
			},
			captchaSeconds: 0, // 验证码倒计时
			ts: +new Date(),
		}
	},
	computed: {
	  disabledBtn() {
	    return this.captchaSeconds > 0 || !this.checkPhone();
	  },
	  disabledcodeBtn() {
		  return !this.checkCaptcha() || !this.checkPhone();
	  }
	},
	beforeDestroy() {
	  clearTimeout(this.captchaTimer);
	},
	methods:{
		onInput(e, key) {
			if (key === 'phone') {
			  this.form[key] = e.target.value.replace(/[^\d]/g, '');
			} else {
			  this.form[key] = e.target.value;
			}
		},
		sendCaptcha() {
		  if (!this.disabledBtn) {
		    this.captchaSeconds = 60;
		    this.startCaptchaTimer();
			var md5 = this.$md5(this.ts + '64!0j1ydr(5+0^o7')
		    requestApi(
		      '/v3/api/v1/send/vcode/',
		      {
		        mobile: this.form.phone,
		        nation_code: DEFAULT_NATION_CODE,
		      },
		      'POST',
			  {
				  ts:this.ts,
				  signature: md5,
			  },
		    );
		  }
		},
		checkPhone() {
		  return this.form.phone.length === 11 && /^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(this.form.phone);
		},
		checkCaptcha() {
			return this.form.captcha.length === 4;
		},
		startCaptchaTimer() {
		  if (this.captchaTimer) {
		    clearTimeout(this.captchaTimer);
		  }
		  this.captchaTimer = setTimeout(() => {
		    this.captchaTimer = null;
		    this.captchaSeconds -= 1;
		    if (this.captchaSeconds < 10) {
		      this.captchaSeconds = `0${this.captchaSeconds}`;
		    }
		    if (this.captchaSeconds > 0) {
		      this.startCaptchaTimer();
		    }
		  }, 1000);
		},
		bindMobile() {
			if(!this.disabledcodeBtn) {
				requestApi(
				  '/v3/api/v1/bind/mobile/',
				  {
				    mobile: this.form.phone,
				    v_code: this.form.captcha,
				  },
				  'POST'
				).then(res => {
					const path = localStorage.loginPrevPage ? JSON.parse(localStorage.loginPrevPage) : '/home';
					window.$router.replace(path);
					localStorage.removeItem('loginPrevPage');
				})
			}
			
		},
	},
}
</script>

<style lang="scss" scoped>
.bind_logo {
	width: 100%;
	background: #fff;
	text-align: center;
	.logo-img {
		width: 172px;
		height: 60px;
		padding: 28px 0 40px 0;
	}
}
.bind_mobile {
	height: calc(100vh - 160px);
	min-height: 600px;
	background: url('../assets/imgs/login-bg.jpg') no-repeat;
	background-position: center;
	background-size: cover;
	position: relative;
}
.bind-dialog {
	background: $C1;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 40px;
	width: 400px;
}
.bind-title {
	font-family: HYXinRenWenSongW;
	font-size: 18px;
	color: $C3;
	margin-bottom: 20px;
}
.inputs-bl {
	.input-wrap {
	  color: $C3;
	  height: 40px;
	  border: 1px solid $A6;
	  width: 100%;
	  display: flex;
	  align-items: center;
	  background: $C1;
	  input {
	    font-size: 16px;
	    border: none;
	    outline: none;
	    height: 100%;
	    flex: 1;
	    padding: 0 0 0 10px;
	  }
	}
	.input-code {
		margin-top: 20px;
		display: flex;
		align-items: flex-start;
	}
	.captcha_btn {
		width: 100px;
		flex-shrink: 0;
		height: 42px;
		background: #CC1014;
		color: #fff;
		cursor: default;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s ease-in;
		line-height: 42px;
		margin-left: 5px;
		font-size: 14px;
		font-weight: 500;
		&.disabled {
		  background: $C10;
		  color: $C13;
		  cursor: default;
		}
	}
}
.bind-login {
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 42px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	background: #CC1014;
	color: #fff;
	transition: all 0.3s ease-in;
	&.disabledcode {
		background: #f3f3f3;
		color: #808080;
		cursor: default;
	}
}


</style>